export const getInitials = (name: string) => {
	if (name) {
		return name
			.split(' ')
			.map((el: string) => el[0])
			.join('')
			.toUpperCase();
	} else {
		return null;
	}
};
